export default __webpack_public_path__ + "static/media/logo-finnet.c031be60.svg";